import { _route, _latLngs, } from '../route-model/Route';
const _c_joinedRoutes = (firstRoute, secondRoute, $map) => {
    const firstLatLngs = _latLngs(firstRoute.s(), firstRoute.e()), secondLatLngs = _latLngs(secondRoute.s(), secondRoute.e()), overallLatLngs = firstLatLngs.concat(secondLatLngs), overallRoute = _route(overallLatLngs, $map);
    return {
        f: firstRoute,
        s: secondRoute,
        o: overallRoute,
    };
}, _c_routesCutAtLine = ($mapLine, $map) => {
    const line = $mapLine.ln();
    return _cutRoutes(line.sp(), line.ep(), $map);
}, _c_routesCutAtPoint = ($marker, $map) => {
    const point = $marker.p();
    return _cutRoutes(point, point, $map);
}, _cutRoutes = (firstEnd, secondStart, $map) => {
    const overallRoute = firstEnd.r(), firstStart = overallRoute.s(), firstLatLngs = _latLngs(firstStart, firstEnd), firstRoute = _route(firstLatLngs, $map), secondEnd = overallRoute.e(), secondLatLngs = _latLngs(secondStart, secondEnd), secondRoute = _route(secondLatLngs, $map);
    return {
        f: firstRoute,
        s: secondRoute,
        o: overallRoute,
    };
};
export { _c_joinedRoutes, _c_routesCutAtLine, _c_routesCutAtPoint, };
